export class AnswerStats {
  completed: number = 0;
  completedPercentage: number = 0;
  total: number = 0;
  noBusinessPartners: number = 0;
  noSuppliers: number = 0;
}
